<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>お勤め先情報の変更</heading-one>

    <errors-alert :errors="errors"></errors-alert>

    <wizard-group class="_mb-md-60 _mb-sm-20">
      <main-wizard :active-index="2" type="useremploy"></main-wizard>
    </wizard-group>

    <p>以下の内容で変更しました。<br>
      その他のお客さま情報を変更する場合は、「お客さま情報を確認する」より変更する箇所をご選択のうえお手続きください。</p>

    <section>
      <heading-two>お勤め先情報</heading-two>

      <table-group>
        <table-box>
          <table-body>
            <table-row>
              <table-header>
                職業
                <change-badge-icon :diffKeys="diffKeys" :key-list="['work_form']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayWorkForm}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                業種
                <change-badge-icon :diffKeys="diffKeys" :key-list="['biz_type']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayBizType}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                職種
                <change-badge-icon :diffKeys="diffKeys" :key-list="['job_type']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayJobType}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                お勤め先
                <change-badge-icon :diffKeys="diffKeys" :key-list="['office_nm']"></change-badge-icon>
              </table-header>
              <table-data>
                {{userData.office_nm}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                お勤め先電話番号
                <change-badge-icon :diffKeys="diffKeys" :key-list="['office_phone_1', 'office_phone_2', 'office_phone_3']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayOfficePhone}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                所属部署
                <change-badge-icon :diffKeys="diffKeys" :key-list="['office_depart']"></change-badge-icon>
              </table-header>
              <table-data>
                {{userData.office_depart}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                入社年月
                <change-badge-icon :diffKeys="diffKeys" :key-list="['nsh_ngt']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayNshNgt}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                社員数
                <change-badge-icon :diffKeys="diffKeys" :key-list="['staff_num']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayStaffNum}}
              </table-data>
            </table-row>
            <table-row>
              <table-header>
                年収（税込）
                <change-badge-icon :diffKeys="diffKeys" :key-list="['gross_salary']"></change-badge-icon>
              </table-header>
              <table-data>
                {{displayGrossSalary}}
              </table-data>
            </table-row>
          </table-body>
        </table-box>
      </table-group>

      <btngroup-single class="_mb-md-120 _mb-sm-40">
        <btn-main class="-main" router-name="mb023">
          お客さま情報を確認する
        </btn-main>
      </btngroup-single>

    </section>
  </div><!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import userData from '../components/mixin/UserData'
import changeIcon from '../components/mixin/ChangeIcon'

import HeadingOne from '../components/heading/HeadingOne'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import HeadingTwo from '../components/heading/HeadingTwo'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import MainWizard from '../components/wizard/MainWizard'
import WizardGroup from '../components/wizard/WizardGroup'
import TableGroup from '../components/tables/TableGroup'
import ChangeBadgeIcon from '../components/badges/ChangeBadgeIcon'
import ErrorsAlert from '../components/alert/ErrorsAlert'
export default {
  name: 'Tem-018',
  metaInfo: {
    title: 'お勤め先情報の変更｜お客さま情報の確認・変更',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報'}
    ]
  },
  mixins: [userData, changeIcon],
  components: {
    ErrorsAlert,
    BtnMain,
    BtngroupSingle,
    TableData,
    ChangeBadgeIcon,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingTwo,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お客さま情報の確認・変更',
        routerName: 'mb023'
      },
      {
        text: 'お勤め先情報の変更',
        active: true
      }
      ],
      input_gross_salary: '',
      errors: {},
      isDisabled: false,
      userData: {
        work_form: '',
        biz_type: '',
        job_type: '',
        office_nm: '',
        office_phone_1: '',
        office_phone_2: '',
        office_phone_3: '',
        office_depart: '',
        nsh_ngt: '',
        staff_num: '',
        gross_salary: ''
      }
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke()
        .then(res => {
          for (let key in res) {
            if (this.userData.hasOwnProperty(key)) {
              this.userData[key] = res[key]
            }
          }
          this.input_gross_salary = this.userData.gross_salary / 10000
        })
        .catch(error => {
          this.goToErrorPage(error)
        })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Tem018.vue